export class DashboardApi {
  constructor(client) { this.client = client; }
  overview(date = '', page = 1, signal = null) {
    const normalizedPage = Math.max(1, Number(page || 1));
    return this.client.call('dashboard.overview.get', { date: String(date || ''), page: normalizedPage, per_page: 10 }, { signal, dedupeKey: `dashboard.overview:${date || 'all'}:${normalizedPage}` });
  }
  dataQuality(signal = null) { return this.client.call('dashboard.data-quality.get', {}, { signal, dedupeKey: 'dashboard.quality' }); }
  vesselPositions(date = '', signal = null) {
    return this.client.call('dashboard.vessel-positions.get', { date: String(date || '') }, { signal, dedupeKey: `dashboard.vessel-positions:${date || 'all'}` });
  }
  weather({ north, south, east, west } = {}, signal = null) {
    return this.client.call('dashboard.weather.get', { north, south, east, west }, { signal });
  }
  weatherTiles({ z, tiles = [], type = 'wind', forecastTime = '' } = {}, signal = null) {
    const normalizedTiles = tiles.map(tile => ({ x: Math.trunc(Number(tile.x)), y: Math.trunc(Number(tile.y)) }));
    const identity = normalizedTiles.map(tile => `${tile.x}/${tile.y}`).sort().join(',');
    return this.client.call(
      'dashboard.weather.tiles.get',
      { z: Math.trunc(Number(z)), type: String(type), forecast_time: String(forecastTime || ''), tiles: normalizedTiles },
      { signal, dedupeKey: `dashboard.weather.tiles:${Math.trunc(Number(z))}:${type}:${forecastTime || 'current'}:${identity}` },
    );
  }
  vesselRoute(vesselId, date = '', signal = null) {
    return this.client.call('dashboard.vessel-route.get', { vessel_id: Number(vesselId), date: String(date || '') }, { signal, dedupeKey: `dashboard.vessel-route:${vesselId}` });
  }
  fleetRoutes(date = '', signal = null) {
    return this.client.call('dashboard.fleet-routes.get', { date: String(date || '') }, { signal, dedupeKey: `dashboard.fleet-routes:${date || 'all'}` });
  }
  updateVoyageStatus(payload) {
    return this.client.call('voyage.status.update', payload);
  }
  getAgent(id, signal = null) {
    return this.client.call('agent.get', { id }, { signal });
  }
}
